import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useCustomPasswordChange = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const changePassword = async (newPassword: string) => {
    setIsLoading(true);

    try {
      // Get the recovery token from localStorage
      const token = localStorage.getItem('recovery_token');
      
      if (!token) {
        throw new Error("No se encontró el token de recuperación");
      }

      // Call our custom change-password edge function
      const { data, error } = await supabase.functions.invoke('change-password', {
        body: { 
          token,
          newPassword 
        }
      });

      if (error) {
        console.error("Edge function error:", error);
        throw new Error(error.message || "Error al cambiar la contraseña");
      }

      if (!data?.success) {
        throw new Error(data?.error || "Error al cambiar la contraseña");
      }

      console.log("Password changed successfully:", data);

      // Clean up tokens from localStorage
      localStorage.removeItem('recovery_token');
      localStorage.removeItem('recovery_email');

      toast({
        title: "Contraseña actualizada",
        description: "Tu contraseña ha sido cambiada exitosamente. Ya puedes iniciar sesión.",
      });

      return { success: true };
    } catch (error: any) {
      console.error("Password change error:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "No se pudo cambiar la contraseña.",
      });
      return { success: false, error: error.message };
    } finally {
      setIsLoading(false);
    }
  };

  return { changePassword, isLoading };
};